import { render, staticRenderFns } from "./AdminNewsPage.vue?vue&type=template&id=26f0f3a3&scoped=true&"
import script from "./AdminNewsPage.vue?vue&type=script&lang=js&"
export * from "./AdminNewsPage.vue?vue&type=script&lang=js&"
import style0 from "./AdminNewsPage.vue?vue&type=style&index=0&id=26f0f3a3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f0f3a3",
  null
  
)

export default component.exports